

























import { Component, Prop, Mixins } from 'vue-property-decorator';
import IsPfdodCheckMixin from '@/mixins/isPfdodCheck';
import { MenuData } from './types';

@Component
export default class Menu extends Mixins(IsPfdodCheckMixin) {
  @Prop({ type: Array, required: true })
  readonly menu!: MenuData;

  @Prop({ type: Number, default: 3 })
  readonly sizeShrinkAndGrow!: number;

  get menuLinks() {
    const { menu } = this;
    if (!Array.isArray(menu)) return [];
    return menu.filter(({ meta, path }) => {
      if (!meta) return false;
      const { title, icon, modules } = meta;
      const isMenuLink = icon || (title && !!title.length);
      if (meta.checkApiModules) {
        const hasApiModule = this.$store.getters.hasApiModule(
          meta.checkApiModules === true ? path : meta.checkApiModules
        );
        if (!hasApiModule) {
          return false;
        }
      }
      return modules
        ? isMenuLink && modules.pfdod && this.isPfdodModule
        : isMenuLink;
    });
  }

  get isShrinkAndGrow(): boolean {
    const { sizeShrinkAndGrow, menuLinks } = this;
    return menuLinks.length > sizeShrinkAndGrow;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/menu/Menu.vue